document.addEventListener("DOMContentLoaded", function () {

const forms = document.querySelectorAll(".luxury-products form");

forms.forEach(function(form){

form.addEventListener("submit", function(e){

e.preventDefault();

const button = form.querySelector(".lp-cart");

const formData = new FormData(form);

button.classList.add("loading");

fetch("/cart/add.js",{

method:"POST",

body:formData

})

.then(res=>res.json())

.then(()=>{

button.classList.remove("loading");

button.classList.add("added");

button.innerHTML="✓";

setTimeout(()=>{

button.classList.remove("added");

button.innerHTML=`
<svg width="20" height="20" viewBox="0 0 24 24" fill="none">

<path d="M6 6H22L20 16H8L6 6Z" stroke="white" stroke-width="2"/>

<circle cx="9" cy="20" r="1.5" fill="white"/>

<circle cx="19" cy="20" r="1.5" fill="white"/>

<path d="M2 2H5L6 6" stroke="white" stroke-width="2"/>

</svg>
`;

},1800);

})

.catch(()=>{

button.classList.remove("loading");

alert("Unable to add product.");

});

});

});

});